var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenubarBookmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "white",
    strokeWidth: 1.5,
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0198 3.5C12.1417 3.5 12.2352 3.60805 12.219 3.72883C11.943 5.79611 11.9772 7.89429 12.3215 9.9538L12.3361 10.0412C12.3531 10.1429 12.4308 10.2238 12.5318 10.2448C12.6328 10.2658 12.7363 10.2226 12.7924 10.1361L14.4161 7.63486C14.4556 7.57413 14.5445 7.57413 14.5839 7.63486L16.2076 10.1361C16.2638 10.2226 16.3672 10.2658 16.4682 10.2448C16.5692 10.2238 16.6469 10.1429 16.6639 10.0412L16.6785 9.9538C17.0228 7.89429 17.057 5.79611 16.781 3.72883C16.7648 3.60805 16.8583 3.5 16.9802 3.5L18.5 3.5C19.3284 3.5 20 4.17157 20 5V20C20 20.5523 19.5523 21 19 21H7.5C5.73676 21 4.27806 19.6961 4.03544 18H4V8C4 5.51472 6.01472 3.5 8.5 3.5L12.0198 3.5ZM7.5 15.5H18.5V19.5H7.5C6.39543 19.5 5.5 18.6046 5.5 17.5C5.5 16.3954 6.39543 15.5 7.5 15.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenubarBookmark);
export default __webpack_public_path__ + "static/media/Menubar_bookmark.2c75b2a4439efaed1f69aae095ba78aa.svg";
export { ForwardRef as ReactComponent };